
const Planner = () => {
  const tasks = document.querySelectorAll('#task');
  const start = document.querySelector('#task-start')
  const end = document.querySelector('#task-end')
  const weekdays = document.querySelector('#task-weekdays');
  const description = document.querySelector('#task-description');

  console.log(tasks);

  tasks.forEach(task => {

    task.addEventListener('click', (e) => {
      start.innerHTML = task.dataset.eventstart;
      if (task.dataset.eventend === undefined) {
        end.style.display = 'none';
      }
      else {
        end.style.display = 'inline-block';

      }
      end.innerHTML = task.dataset.eventend;
      weekdays.innerHTML = task.dataset.weekdays;
      description.innerHTML = task.dataset.description;
    })
  })

}

export default Planner;
